import React from "react";
import { CreateNFeContext } from "../../../Context";
import Text from "../../../../../../../_components/Text";
import { _Input } from "../../../../../../../_components/Input";

const options = [
  {
    label: "0=Entrada",
    value: "0",
  },
  {
    label: "1=Saída",
    value: "1",
  },
];

export default (props) => {
  const context = React.useContext(CreateNFeContext);

  function onChange(e) {
    const { nfe } = context;
    nfe.identification.tp_nf = e.value;
    context.handlers.updateNFeData(nfe);
  }

  return (
    <div className="">
      <_Input
        type="select"
        value={context.nfe.identification.tp_nf}
        onChange={onChange}
        label="* Tipo de Documento Fiscal"
        options={options}
      />
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/views/Fiscal/NFe/Issuer/Identification/Details/TPNF/index.jsx